<script setup lang="ts">
withDefaults(
  defineProps<{ product: ProductCard, highlighted: boolean, titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6', wrapperClass?: string }>(),
  {
    titleTag: 'h1',
    wrapperClass: '',
  },
)
</script>

<template>
  <ContentGrid class="items-center">
    <div :class="wrapperClass" class="col-span-4 md:col-span-3 lg:col-span-5 2xl:col-span-6 2xl:col-start-2 flex flex-col">
      <component :is="titleTag" :class="{ 'text-brand': highlighted }">
        {{ product.title }}
      </component>

      <p v-if="product.subtitle" class="title-m font-semibold" :class="{ 'text-white': highlighted }" v-text="product.subtitle" />

      <CrystallizeRichText v-for="(block, key) in product.variant?.components.description" :key="key" class="font-heading text-2xl font-light" :block="block" :class="{ 'text-white': highlighted }" />
    </div>
    <slot />
  </ContentGrid>
</template>
